export const TourismServices = {
    1: 'TOURISM_SERVICE_1',
    2: 'TOURISM_SERVICE_2',
    3: 'TOURISM_SERVICE_3'
}